import { UseFormReturn } from "react-hook-form";
import { IStructureVacancyRequestDto } from "@src/entities/requestHH/api/interfaces/jobRequestDto";
import { Button } from "@src/shared/components/Button/Button";
import { StepHeader } from "../StepHeader/StepHeader";
import { InputField } from "@src/shared/ui/InputField";
import { TextArea } from "@src/shared/ui";
import { textareaStyles } from "@src/features/creatingSearchHH/ui/constans";

import styles from "./VacancyDescriptionStep.module.scss";
import { useUserInfoMeStore } from "@src/entities/user/model/store/userInfoMeStore";

interface Props {
  form: UseFormReturn<IStructureVacancyRequestDto>;
  isLoading: boolean;
  onSubmit: (values: IStructureVacancyRequestDto) => void;
}

export const VacancyDescriptionStep = ({
  form,
  isLoading,
  onSubmit,
}: Props) => {
  const user = useUserInfoMeStore((state) => state.user);
  const {
    handleSubmit,
    control,
    formState: { isValid },
  } = form;

  const attemptsInfo = `Количество запросов: ${(user?.last_license?.used_request ?? 0)} /
          ${(user?.last_license?.available_attempts ?? 0)}`;

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.header}>
        <h2 className={styles.formTitle}>Общие требования к вакансии</h2>
        <StepHeader step={1} />
      </div>

      <div className={styles.divider} />

      <div className={styles.fields}>
        <div className={styles.field}>
          <label className={styles.label}>Название вакансии:</label>
          <InputField
            control={control}
            name="vacancy_name"
            placeholder="Наименование специальности"
            className={styles.inputField}
            classNameForWrapper={styles.inputFieldWrapper}
          />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Текст вакансии:</label>
          <TextArea
            className={styles.textAreaDes}
            name="vacancy_description"
            control={control}
            sx={textareaStyles}
            placeholder="Полный текст вакансии"
          />
        </div>

        <div className={styles.field}>
          <label className={styles.label}>Сфокусировать поиск:</label>
          <InputField
            control={control}
            name="user_comments"
            placeholder="Описание критичных требований к кандидатам (в свободной форме), для фокуса промпта на поиск"
            className={styles.inputField}
          />
        </div>
      </div>

      <div className={styles.footer}>
        <span className={styles.requestCount}>{attemptsInfo}</span>

        <Button
          btnText="Обработать"
          typeBtn="submit"
          isDisabled={!isValid || isLoading}
        />
      </div>
    </form>
  );
};
